import { useCallback, useMemo } from "react";
import { useSdkContext } from "~/components/contexts";
import { useFallbackStorageValue } from "~/lib/hooks";
export const useNotificationHistory = () => {
  const {
    user
  } = useSdkContext();
  const {
    set,
    value
  } = useFallbackStorageValue("localLatestPushNotificationHistory", {});
  const addNotificationHistory = useCallback(entityUuid => {
    const now = new Date();
    set(histories => {
      const newValue = histories !== null && histories !== void 0 ? histories : {};
      newValue[entityUuid] = {
        createdAt: now.getTime(),
        entityUuid,
        expiresAt: new Date().setDate(now.getDate() + 7),
        userUuid: user === null || user === void 0 ? void 0 : user.uuid
      };
      return newValue;
    });
  }, [set, user === null || user === void 0 ? void 0 : user.uuid]);
  const notificationHistory = useMemo(() => {
    if (!value) return new Set();
    const now = Date.now();
    return new Set(Object.values(value).filter(history => history.userUuid === (user === null || user === void 0 ? void 0 : user.uuid) && history.expiresAt > now).map(history => history.entityUuid));
  }, [user === null || user === void 0 ? void 0 : user.uuid, value]);
  return {
    addNotificationHistory,
    notificationHistory
  };
};